import Vue from 'vue'
import Router from 'vue-router'
import { jsSign } from '@/api/home'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      name: 'newList',
      path: '/',
      component: () => import('@/views/newList')
    },
    {
      name: 'newPage',
      path: '/newPage',
      component: () => import('@/views/newPage')
    },
    {
      name: 'level3',
      path: '/level3',
      component: () => import('@/views/level3')
    }
  ]
})

router.afterEach(() => {
  const href = location.href.split('#')[0]
  jsSign({
    url: href
  }).then(({body}) => {
    window.wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: body.appid, // 必填，公众号的唯一标识
      timestamp: body.timestamp, // 必填，生成签名的时间戳
      nonceStr: body.nonceStr, // 必填，生成签名的随机串
      signature: body.signature,// 必填，签名
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
    })
    window.wx.ready(function(){
      console.log('准备')
      window.wx.updateAppMessageShareData({ 
        title: '寻找"初心的足迹"', // 分享标题
        desc: '杭州公安党史学习教育纪实', // 分享描述
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://hzgagzh-1254071088.cos.ap-shanghai.myqcloud.com/hzga/logo.png', // 分享图标
        success: function () {
          // 设置成功
          console.log('自定义“分享给朋友”及“分享到QQ”按钮的分享内容')
        },
        fail: function (fail) {
          console.log('updateAppMessageShareData:' + JSON.stringify(fail))
        }
      })
      window.wx.updateTimelineShareData({ 
        title: '寻找"初心的足迹"——杭州公安党史学习教育纪实', // 分享标题
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://hzgagzh-1254071088.cos.ap-shanghai.myqcloud.com/hzga/logo.png', // 分享图标
        success: function () {
          // 设置成功
          console.log('自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容')
        },
        fail: function (fail) {
          console.log('updateAppMessageShareData:' + JSON.stringify(fail))
        }
      })
    })
    window.wx.error(function(res){
      console.log('错误' + JSON.stringify(res))
    })
    window.wx.checkJsApi({
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function(res) {
        console.log(JSON.stringify(res))
      }
    })
  })
})


export default router